import { render, staticRenderFns } from "./buyCar.vue?vue&type=template&id=ebd0d50e&scoped=true&"
import script from "./buyCar.vue?vue&type=script&lang=js&"
export * from "./buyCar.vue?vue&type=script&lang=js&"
import style0 from "./buyCar.vue?vue&type=style&index=0&id=ebd0d50e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd0d50e",
  null
  
)

export default component.exports